import { render, staticRenderFns } from "./InventoryRequestEditItemList.vue?vue&type=template&id=671fc9b9&"
import script from "./InventoryRequestEditItemList.vue?vue&type=script&lang=js&"
export * from "./InventoryRequestEditItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports